<script>
import Layout from "../../layouts/main";
import PageHeader from '@/components/page-header-custom.vue';
import appConfig from "@/app.config";
import { layoutMethods, layoutComputed } from "@/state/helpers"
import Toast from "@/components/widgets/toast.vue";


export default {
  page: {
    title: "My Space",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      toastTitle: "",
      toastMessage: "",
      toastType: "",
      showToast: false
    };
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  computed: {
    ...layoutComputed
  },
  methods: {
    ...layoutMethods,
    openToast(toast) {
      this.toastType = toast.type;
      this.toastTitle = toast.title;
      this.toastMessage = toast.message;
      this.showToast = true;
    }
  }
};
</script>

<template>
  <Layout >
    <PageHeader :title="title" :items="breadCrumbs" :prev="{name:'',params:{}}" :backButton="showBackButton"/>
    <router-view @show-toast="openToast"/>
    <toast 
      :type="toastType" 
      v-if="showToast" 
      @close="() => showToast = false" 
      :title="toastTitle" 
      :message="toastMessage"/>
  </Layout>
</template>